export enum NotificationType {
  MARKET_SUSPENDED = 'altgame.reddog.catalog.v2.market.suspended',
  BALANCE_CHANGED = 'altgame.reddog.wallet.v2.balance.changed',
  ORDER_LIMIT_UPDATED = 'altgame.reddog.order.v2.limit.updated',
  ORDER_UPDATED = 'altgame.reddog.order.v2.updated',
  NOTIFICATION_UPDATED = 'altgame.reddog.catalog.v2.notification.updated',
  MARKET_DISABLED = 'altgame.reddog.catalog.v2.market.disabled',
}
